import React, { useState, useEffect } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter as Router } from 'react-router-dom';
import keycloak from './keycloak';
import App from './App';

const Root = () => {
    const [keycloakInitialized, setKeycloakInitialized] = useState(false);

    useEffect(() => {
        keycloak.init({
            onLoad: 'check-sso',
            silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
        }).then((authenticated) => {
            if (authenticated) {
                setKeycloakInitialized(true);
            } else {
                keycloak.login();
            }
        });
    }, []);

    if (!keycloakInitialized) {
        return <div></div>;
    }

    return (
        <Router>
            <App />
        </Router>
    );
};

const container = document.getElementById('root');
const root = createRoot(container);
root.render(<Root />);
